import request, { requestV2 } from 'store/common/utils';
export const getPaymentPlansApi = (id) => request({
    url: `paymentPlans${id ? `/${id}` : ''}`,
    method: 'GET',
});
export const createPaymentPlanApi = (data) => request({
    url: '/paymentPlans',
    method: 'POST',
    data,
});
export const editPaymentPlanApi = (data) => request({
    url: `/paymentPlans/${data.id}`,
    method: 'PUT',
    data,
});
export const deletePaymentPlanApi = ({ id }) => request({
    url: `/paymentPlans/${id}`,
    method: 'DELETE',
});
export const createPaymentPlanItemApi = (data) => request({
    url: `/paymentPlans/${data.paymentPlanId}/items`,
    method: 'POST',
    data,
});
export const editPaymentPlanItemApi = (data) => request({
    url: `/paymentPlans/${data.paymentPlanId}/items/${data.id}`,
    method: 'PUT',
    data,
});
export const copyPaymentPlanApi = (paymentPlan, projectIds) => request({
    url: `/paymentPlans/${paymentPlan.id}/copy`,
    method: 'POST',
    data: { projectIds },
});
export const deletePaymentPlanItemApi = (data) => request({
    url: `/paymentPlans/${data.paymentPlanId}/items/${data.id}`,
    method: 'DELETE',
});
export const syncProjectPaymentPlansApi = (projectId, data) => request({
    url: `/projects/${projectId}/paymentPlans/sync`,
    method: 'POST',
    data,
});
// API V2 =========================================== //
/**
 * Returns a list of all payment plans associated with the specified project.
 * The response includes both published and unpublished plans, allowing clients to manage and display all available options.
 * This endpoint is useful for retrieving current pricing structures, installment options, and other related configurations defined for the project.
 */
export const getPaymentPlansApiV2 = (projectId) => requestV2({
    url: 'payment-plans',
    method: 'GET',
    params: { projectId },
    headers: { 'x-api-scope': 'admin' },
});
export const getPublicPaymentPlansApiV2 = (projectId) => requestV2({
    url: 'payment-plans',
    method: 'GET',
    params: { projectId },
});
/**
 *
Replaces the entire set of payment plans for the specified project with the provided state snapshot.

This operation acts as a full synchronization: it can
create new payment plans,
update existing ones,
delete removed plans,
and reorder plans within the project.

Behavior:
Any existing payment plans not included in the request will be deleted.
Plans with matching IDs will be updated with the provided data.
Plans without IDs will be created.
The sort order will be updated according to the request payload.
 */
export const syncPaymentPlansApi = (data) => requestV2({
    url: 'payment-plans',
    method: 'POST',
    data,
    headers: { 'x-api-scope': 'admin' },
});
/**
 * Copies existing payment plans from the specified project to one or more target projects.
 *
 * This includes the ability to duplicate plans within the same project.
 *
 * All copied payment plans will be created as unpublished, allowing for review and customization before they are made public.
 *
 * This endpoint is useful for reusing standardized payment structures across multiple projects.
 */
export const copyPaymentPlansApi = (projectId, data) => requestV2({
    url: 'payment-plans/copy',
    method: 'POST',
    data,
    headers: { 'x-api-scope': 'admin' },
});
